<div class="footer">
  <div class="version">
    @if (flyGarminVersion != null) {
      <div
        aria-hidden="true"
        class="fly-version"
        [innerHTML]="flyGarminVersion()">
      </div>
    }
  </div>
</div>
